import axios from 'axios';
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from '@mui/material';
import WebService from '@util/webService'
import { encodeParams, getAction, printVariable, removeNonDigits } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { schoolGrades } from '@util/schoolInfo';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';
import { findCode } from '@util/helper';
import useDelegate from "@hooks/useDelegate";
import useAlert from "@hooks/useAlert";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConfirmDialog from '@components/ConfirmDialog';
import ManagerStudentSchedule from './manager-student.part.schedule'
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;

const FormHelperTexts = styled(FormHelperText)`
width: 100%;
padding-left: 16px;
font-weight: 700 !important;
color: #d32f2f !important;
font-size: 0.85rem !important;
`

const ManagerStudentPart = ({ fields, record, callback, dialogHandler, setCloseHandler }) => {
  console.log('ManagerStudentPart rendering...');
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const schoolMap = new Map(schools.map(s => [s.id, s]))
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const updateRef = useRef(false)
  const { alert, renderAlert } = useAlert()
  const inputsRef = useRef({})
  const [emailError, setEmailError] = useState('');
  const [passwordState, setPasswordState] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [nameError, setNameError] = useState('');
  const [registerError, setRegisterError] = useState('');
  const [schoolList, set_schoolList] = useState([])
  const [blindList, set_blindList] = useState([])
  const [isExpanded, set_isExpanded] = useState(false)
  const [accordionKey, set_accordionKey] = useState(0)
  const theme = useTheme()

  const fetchStudent = async () => {
    const url = `/student/${record.id}`
    openIndicator()
    const resp = await WebService.get(url, { phone: record.gdnPhone })
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const gdn = JSON.parse(repMessage.gdn)
    const regiAndLectureList = JSON.parse(repMessage.regiAndLectureList)
    factor.gdn = gdn
    factor.regiAndLectureList = regiAndLectureList
    console.log('regiAndLectureList', regiAndLectureList)
    updateState()
  }

  const fetchBlindList = async () => {
    if (factor.id < 0) {
      return
    }

    const url = `/student/blind/${record.schoolId}`
    const resp = await WebService.get(url, { studentName: record.name })
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const blindList = JSON.parse(repMessage.blindList)
    blindList?.forEach(item => {
      item.studentList.forEach(student => {
        student.visible = true
      })
    })
    console.log('blindList=>', blindList)
    set_blindList(blindList || [])

  }

  const onLoad = async () => {
    await fetchStudent()
    await fetchBlindList()
  }

  useEffect(() => {
    onLoad()
  }, [record])

  const gdnFields = [
    { field: 'name', placeholder: '성명' },
    { field: 'loginId', placeholder: 'ID' },
    { field: 'phone', placeholder: '전화번호' },
    { field: 'phoneCertYn', placeholder: '휴대폰인증' },
    { field: 'emailCertYn', placeholder: '이메일인증' },
  ]

  const regiLectureFields = [
    { field: 'year', placeholder: '년도', table: 'smst' },
    { field: 'gisu', placeholder: '기수', table: 'smst' },
    { field: 'title', placeholder: '강좌제목', table: 'lecture' },
    { field: 'statCode', placeholder: '강좌상태', table: 'lecture', fn: (code) => findCode(codes, 'SA08', code) },
    { field: 'statCode', placeholder: '신청상태', table: 'regi', fn: (code) => findCode(codes, 'SA12', code) },
    { field: 'moveBlind', placeholder: '관리', },

  ]

  const handleClose = () => {
    dialogHandler[1](false)
    if (callback) {
      callback(updateRef.current)
    }
  }

  // MyDialog3 오른쪽 상단 닫기도 같은 처리를 하도록 등록
  useEffect(() => {
    if (setCloseHandler) {
      setCloseHandler(handleClose)
    }
  }, [setCloseHandler])

  const onSubmit = async () => {
    const url = '/student'
    const moveRegiIds = factor.regiAndLectureList.filter(r => r.moved).map(r => r.regi.id)
    const data = { ...activeRow, id: factor.id, moveRegiIds: [...moveRegiIds] }
    console.log('data=>', data)
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const student = JSON.parse(repMessage.record)
      factor.id = student.id

      updateState()
      updateRef.current = true
      alert('저장되었습니다.', () => { onLoad() })
    }
    else {
      alert(resp.repMessage)
    }
  }

  const validate = async (name, value) => {
    let err = ''
    if (name === 'name') {
      if (!value) {
        err = '이름을 입력해 주세요.'
      }
    }
    if (name === 'grade') {
      if (!value) {
        err = '학년을 입력해 주세요'
      }
      else {
        // let grades = [1, 2, 3, 4, 5, 6]

        const grades = schoolGrades[schola?.id] ?? [1,2,3,4,5,6]
        if (!grades.includes(+value)) {
          err = '알 수 없는 학년입니다.'
        }
      }
    }
    if (name === 'className') {
      if (!value) {
        err = '반을 입력해 주세요'
      }
    }
    if (name === 'classNum') {
      if (!value) {
        err = '번호를 입력해 주세요'
      }
    }
    if (name === 'gdnPhone') {
      if (!value) {
        err = '보호자 전화번호를 입력해 주세요'
      }
      else {
        if(value.startsWith('010')) {
          if (value.length !== 11) {
            err = '보호자 전화번호 길이가 맞지 않습니다.'
          }
        }
        else { // 베트남 전화번호  길이
          if (value.length < 9 || value.length > 11) {
            err = '보호자 전화번호 길이가 맞지 않습니다.(2)'
          }
        }
        // if (value.length !== 11) {

      }
    }
    return err
  }


  const { activeRow, errors, updateState, handleChange, handleSubmit, factor } = useDelegate({
    initialValues: { ...record },
    onSubmit: onSubmit,
    validate: validate,
  });






  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };



  const MyAccordion = () => {
    const [total, set_total] = useState(0)

    useEffect(() => {
      const total = blindList.reduce((acc, smst) =>
        acc + (smst.studentList?.filter(s => s.visible).length || 0), 0
      )
      set_total(total)
    },[blindList])

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }} gap={1}>
        <Grid container >
          <Grid item xs={12}>
            <Accordion
              expanded={isExpanded}
              onChange={(e, expanded) => set_isExpanded(expanded)}
            >
              <AccordionSummary
                id={`blindList`}
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: '#fafafa',
                  height: 30,
                  minHeight: 30,
                  '& .MuiAccordionSummary-content': {
                    margin: 0,
                    alignItems: 'center',
                  },
                  '&.Mui-expanded': {
                    minHeight: 30,
                  },
                }}
              >
                <Typography>
                  학생을 구분할 수 없어 블라인드 처리된 수강신청 목록: {total}
                </Typography>

              </AccordionSummary>
              <AccordionDetails>
                {
                  blindList.map((smst) => (
                    <Grid item xs={12} key={`smst-${smst.id}`} >
                      {
                        smst?.studentList?.filter(r => r.visible).map((student) => (
                          <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid #f0f0f0' }}>
                            <Typography
                              key={`blindStudent-${student.id}-${student.regi.id}`}
                              style={{ flex: 1, display: 'flex' }}
                              variant='body2'
                            >
                              {/* 각 항목을 span으로 감싸고 고정 폭을 주어 열을 맞춤 */}
                              <span style={{ width: '100px', flexShrink: 0 }}>{smst.year}/{smst.gisu}</span>
                              <span style={{ width: '150px', flexShrink: 0, }}>
                                {student.name}({student.grade}/{student.className}/{student.classNum})
                              </span>
                              <span style={{ width: '130px', flexShrink: 0 }}>{student.gdnPhone}</span>

                              {/* 강좌명은 남은 공간을 다 쓰도록 flex-1 */}
                              <span style={{
                                flex: 1,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                paddingRight: '10px'
                              }}>
                                {student.lecture.title}({student.lecture.id}, {findCode(codes, 'SA08', student.lecture.statCode)?.name?? '' })
                              </span>

                            </Typography>

                            <ConfirmDialog
                              btn={
                                <FlatButton  sx={{ whiteSpace: 'pre-line' }}>
                                  현행 학생 정보로 수강신청 이동
                                </FlatButton>
                              }
                              title={'주의'}
                              content= {() => {
                                if(student.gdnPhone != activeRow.gdnPhone) {
                                  return '보호자의 전화번호가 일치하지 않습니다. 그래도 수강신청을 이동하시겠습니까?'
                                }
                                else {
                                  return ''
                                }
                              }}
                              bc={'error'}
                              preHandle={() => {
                                if(student.lecture.phase >= 7 ) {
                                  alert('종강된 강좌는 현행화 할 수 없습니다.')
                                  return false
                                }
                                return true
                              }}
                              perform={() => {
                                const td = {
                                  smst: { ...smst },
                                  student: { ...student },
                                  regi: { ...student.regi },
                                  lecture: { ...student.lecture },
                                  moved: true
                                }

                                factor.regiAndLectureList.push(td)
                                updateState()

                                student.visible = false
                                set_blindList([...blindList])
                              }}
                            />

                            {/* <Button variant="outlined" size="small" style={{ whiteSpace: 'nowrap' }}
                              onClick={() => {
                                const td = {
                                  smst: { ...smst },
                                  student: { ...student },
                                  regi: { ...student.regi },
                                  lecture: { ...student.lecture },
                                  moved: true
                                }

                                factor.regiAndLectureList.push(td)
                                updateState()

                                student.visible = false
                                set_blindList([...blindList])
                              }}
                            >
                              현행 학생 정보로 수강신청 이동
                            </Button> */}
                          </div>
                        ))
                      }
                    </Grid>
                  ))
                }
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>

      </Box>

    )
  }

  return (
    <Container component="main" maxWidth="lg">
      <Box
        sx={{
          marginTop: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography component="h1" variant="h5">
          기본정보
        </Typography>
        <Boxs component="form" noValidate sx={{ mt: 3 }}>
          <FormControl component="fieldset" variant="standard" fullWidth>
            <Grid container spacing={2}>
              {
                fields.map((col, index) => {
                  if (col.visible) {
                    if (col.field === 'ftYn') {
                      return (
                        <>
                          <Grid item xs={12} sm={3} key={col.field}>
                            <FormControl fullWidth>
                              <InputLabel required id='ftYn' >
                                {col.placeholder}
                              </InputLabel>
                              <Select
                                labelId='ftYn'
                                required
                                label={col.placeholder}
                                name={col.field}
                                defaultValue={activeRow[col.field]}
                                onChange={handleChange}
                              >
                                {
                                  col.selList.map(l => {
                                    return (
                                      <MenuItem key={l} value={l}>{l}</MenuItem>
                                    )
                                  })
                                }
                              </Select>
                            </FormControl>

                          </Grid>
                        </>
                      )
                    }
                    else if (col.type === 'auto') {
                      return (
                        <Grid item xs={12} sm={3} key={col.field}>
                          <Autocomplete
                            disablePortal
                            options={schoolList}
                            name={col.field}
                            value={schoolMap.get(+activeRow[col.field])}
                            onInputChange={async (event, value, reason) => {
                              if (reason === 'input') {
                                const records = await searchSchool(value)
                                set_schoolList(records)
                              }
                            }}
                            onChange={(e, v) => {
                              activeRow[col.field] = v.id
                            }}
                            size='small'
                            getOptionLabel={(option) => option.label}
                            readOnly={true}
                            renderInput={(params) => <TextField  {...params} label="학교명" />}
                          />
                        </Grid>
                      )
                    }
                    else {
                      return (
                        <Grid item xs={12} sm={3} key={col.field}>
                          <TextField
                            size='small'
                            required
                            disabled={col.field === 'id' ? true : false}
                            fullWidth
                            name={col.field}
                            label={col.placeholder}
                            inputRef={el => inputsRef.current[col.field] = el}
                            value={col.field === 'id' ? activeRow[col.field] : undefined}
                            defaultValue={activeRow[col.field]}
                            onChange={e => {
                              if (col.field === 'gdnPhone' || col.field === 'grade' || col.field === 'classNum') {
                                const newVal = removeNonDigits(e.target.value)
                                inputsRef.current[col.field].value = newVal
                              }
                              handleChange({ name: col.field, value: e.target.value.trim() })
                            }}
                            inputProps={
                              col.field == 'gdnPhone' ? {
                                maxLength: 11
                              } : {}
                            }
                          />
                          <FormHelperTexts>{errors[col.field]}</FormHelperTexts>
                        </Grid>
                      )
                    }
                  }
                })
              }
            </Grid>
          </FormControl>
          <FormHelperTexts>{registerError}</FormHelperTexts>
        </Boxs>
        <Divider />
        <Typography component="h1" variant="h5">
          보호자 정보
        </Typography>
        <Box sx={{ mt: 1, width: '100%' }}>
          <Grid container sx={{ bgcolor: '#fafafa', display:'flex', alignItems:'center', height:35}}>
            {
              gdnFields.map(d => {
                return (
                  <Grid item xs={12} sm={2}>{d.placeholder}</Grid>
                )
              })
            }
          </Grid>
          <Grid container>
            {
              gdnFields.map(d => {
                return (
                  <Grid item xs={12} sm={2} sx={{ fontSize: '0.9em' }} >{activeRow.gdn[d.field]}</Grid>
                )
              })
            }
          </Grid>
        </Box>
        {
          activeRow.remark.trim().length > 0 ? (
            <>
              <Divider sx={{ mt: 5 }} />
              <Typography component="h1" variant="h5" >
                비고
              </Typography>
              <Typography>
                {activeRow.remark}
              </Typography>

              {/* <Box sx={{mt:1, width:'100%'}}>
                <TextField
                  rows={5}
                  fullWidth
                  multiline
                  label={'비고'}
                  defaultValue={activeRow.remark}
                  onChange={ e => {
                    activeRow.remark = e.target.value
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.stopPropagation(); // prevent form submit
                    }
                  }}
                />
              </Box> */}
            </>
          ) : null
        }


        <Divider sx={{ mt: 5 }} />
        <Typography component="h1" variant="h5" >
          수강(신청) 정보
        </Typography>
        <Box sx={{ mt: 1, width: '100%' }}>
          <Grid container sx={{ bgcolor: '#fafafa', height:30, display:'flex', alignItems:'center'}}>
            {
              regiLectureFields.map(d => {
                return (
                  <Grid item xs={12 / regiLectureFields.length}>
                    {d.placeholder}
                  </Grid>
                )
              })
            }
          </Grid>
          <Grid container spacing={1}>
            {
              activeRow.regiAndLectureList.map(row => {
                return (
                  regiLectureFields.map(col => {
                    if (col.fn && row[col.table][col.field]) {
                      const code = col.fn(row[col.table][col.field])

                      return (
                        <Grid item xs={12 / regiLectureFields.length} sx={{ fontSize: '0.9em' }}>
                          {code ? code.name : ''}
                        </Grid>
                      )
                    }
                    else if (col.table && col.field) {
                      return (
                        <Grid item xs={12 / regiLectureFields.length} sx={{ fontSize: '0.9em' }}>
                          {row[col.table][col.field]}
                        </Grid>
                      )
                    }
                    else {
                      if (col.field === 'moveBlind' && row.moved) {
                        return (
                          <Grid item xs={12 / regiLectureFields.length} sx={{ fontSize: '0.9em' }}>
                            <FlatButton
                              onClick={() => {
                                console.log('row=>', row)

                                const targetSmst = blindList.find(r => r.id === row.smst.id)
                                console.log('row.student.id=?', row.student.id)
                                const targetStudent = targetSmst?.studentList?.find(st => st.regi?.id === row.regi.id)
                                if (targetStudent) {
                                  console.log('targetStudent=>', targetStudent)
                                  targetStudent.visible = true
                                  set_blindList([...blindList])
                                }


                                factor.regiAndLectureList = factor.regiAndLectureList.filter(r => r.regi.id !== row.regi.id)
                                updateState()

                              }}
                            >
                              이동 취소
                            </FlatButton>
                          </Grid>
                        )
                      }
                      else {
                        return (
                          <Grid item xs={12 / regiLectureFields.length} sx={{ fontSize: '0.9em' }}>
                          </Grid>
                        )
                      }
                    }

                  })
                )
              })
            }

            <Grid item xs={12}>
              <Divider />
            </Grid>
            {
              activeRow.regiAndLectureList.filter(r => r.moved)?.length > 0 ? (
                <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
                  <Typography color={theme.palette.secondary.main} variant='body2' >
                    * 수강신청 이동은 저장 버튼 클릭 후 현행화 됩니다. 저장된 이후에는 취소할 수 없으니 보호자 전화번호가 다를 경우 특히 주의하여 사용해 주시기 바랍니다.
                  </Typography>

                </Grid>
              ) : null
            }
            <Grid item xs={12} style={{marginTop:10}}>
              <MyAccordion />
            </Grid>

          </Grid>
        </Box>
        {
          factor.id > 0 ? (
            <>
              <Divider sx={{ mt: 5 }} />
              <ManagerStudentSchedule
                student={{ id: factor.id, schoolId: activeRow.schoolId }}
                regiAndLectureList={activeRow.regiAndLectureList}
              />
            </>
          ) : null
        }
      </Box>
      <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
        <Button variant='outlined' color='primary' size='small' onClick={handleClose} sx={{ mt: 5, mr: 1 }} >
          닫기
        </Button>
        <Button variant='contained' color='primary' size='small' onClick={handleSubmit} sx={{ mt: 5 }}>
          저장
        </Button>
      </div>
      {renderIndicator()}
      {renderAlert()}
    </Container>
  );

}

export default ManagerStudentPart
